export const en = {
  title: 'A SenSai insight',
  closeLabel: 'Dismiss',
  footnote: {
    /**
     * %s is the position of the linkLabel inside the footnote sentence,
     * e.g. "For more insights like these, open SenSai from your %s page."
     */
    text: 'For more insights like these, open SenSai from your %s page.',
    linkLabel: 'My 5 Dynamics',
  },
}

export const es = en
